import React from 'react';
import { Link } from 'react-router-dom';

interface SearchButtonGroupProps {
  queryInProgress: boolean;
  onSearch: () => void;
  isSearchDisabled: boolean;
  addNewLink: string;
  addNewTestId: string;
  addNewLabel: string;
}

export const SearchButtonGroup: React.FC<SearchButtonGroupProps> = ({
  queryInProgress,
  onSearch,
  isSearchDisabled,
  addNewLink,
  addNewTestId,
  addNewLabel,
}) => {
  return (
    <div className="w-80 pt-9">
      <div className="flex flex-row space-x-2 px-10">
        {!queryInProgress && (
          <button
            className="btn btn-primary w-40"
            onClick={onSearch}
            disabled={isSearchDisabled}
          >
            Search
          </button>
        )}
        {queryInProgress && (
          <span className="loading loading-spinner loading-lg"></span>
        )}
        {!queryInProgress && (
          <Link
            data-testid={addNewTestId}
            to={addNewLink}
            className="btn btn-secondary w-40"
          >
            {addNewLabel}
          </Link>
        )}
      </div>
      <div className="max-w-xs py-4 flex"></div>
    </div>
  );
};
